const memoize = (func) => {
  const cache = new Map();
  return (...args) => {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = func(...args);
    cache.set(key, result);
    return result;
  };
};

export const createSelector = (...funcs) => {
  const resultFunc = funcs.pop();
  const memoizedResultFunc = memoize(resultFunc);
  
  return (state, ...args) => {
    const params = funcs.map(func => func(state, ...args));
    return memoizedResultFunc(...params);
  };
};
